module.exports = __webpack_public_path__ + "img/34_9.58598a4c.png";